import $ from 'jquery';
import Component from "../models/Component";
import {
	gsapSingleton,
	customEaseSingleton
} from "../gsap";
const gsap = gsapSingleton();
const CustomEase = customEaseSingleton();

gsap.registerPlugin(CustomEase);


export default class MainMenu extends Component {
	constructor(element, context) {
		super(element, context);
		$(() => {
			this.init();
		});
	}


	moveheight() {
		var lastScrollTop = 0;
		var scrollTimeout;


		$(window).scroll(function () {
			var scrolltop = $(this).scrollTop();
			var headerHeight = $('header').outerHeight();

			if (window.innerWidth > 1024) {
				if (!$('body').hasClass('open-menu')) {
					if (scrolltop < lastScrollTop) {
						$('header').removeClass('move-height');
					} 
					else {
						$('header').addClass('move-height');
					}

					if (scrolltop == 0) {
						setTimeout(function () {
							$('header').removeClass('move-height');
						}, 250);
					}
				}
			}

			// Cancella il timeout precedente
			clearTimeout(scrollTimeout);

			// Imposta un nuovo timeout per rimuovere la classe dopo 2 secondi
			scrollTimeout = setTimeout(function () {
				$('header').removeClass('move-height');
			}, 500);

			// Controlla se lo scroll ha superato l'altezza dell'header
			if (scrolltop > headerHeight) {
				$('header').addClass('always-white');
			} else {
				$('header').removeClass('always-white');
			}

			lastScrollTop = scrolltop;
		});

	}



	init() {
		let FirstItemswithSubmenu = this.element.find('.menu-items > .menu-item-has-children');

		CustomEase.create("in-out", "0.42,0,0.58,1")
		this.moveheight();
		if (window.innerWidth > 1024) {

			$('.sub-menu-0').removeClass('active');
			$(FirstItemswithSubmenu).find('a').removeClass('active-submenu');
			$('header').removeClass('hovered');

			$(FirstItemswithSubmenu).hover(
				function () {
					let item = $(this).find('a');
					let subMenuitem = $(this).find('.sub-menu-0');

					// Controlla se il mouse è sull'elemento
					if (!$(this).is(':hover')) return;

					// Rimuovi altre classi attive e aggiungi solo a quello attuale
					$('.active').not(subMenuitem).removeClass('active');
					$(subMenuitem).addClass('active');
					$(item).addClass('active-submenu');
					$('header').addClass('hovered');
				},
				function () {
					let item = $(this).find('a');
					let subMenuitem = $(this).find('.sub-menu-0');

					// Rimuovi classi solo se non più in hover
					if ($(this).is(':hover')) return;

					$(subMenuitem).removeClass('active');
					$(item).removeClass('active-submenu');
					$('header').removeClass('hovered');
				}
    		);

		} else {

			let hamburgher = $('.hamburgerc');
			let menuIcon = $('.menu-item-has-children a');

			$(hamburgher).on('click', function () {
				const $this = $(this); // Salva il riferimento all'elemento cliccato
				const $menuItems = $('#menu-items');
				const $htmlBody = $('html, body');
				const $span = $this.find('span'); // Trova lo span all'interno del bottone
				
		
				if ($this.hasClass('is-active')) {
					$this.removeClass('is-active');
					$menuItems.hide();
					$htmlBody.removeClass('open-menu no-scroll');
					$('header').removeClass('hovered');
					$span.text('menu');
				} else {
					$this.addClass('is-active');
					$menuItems.show();
					$htmlBody.addClass('open-menu no-scroll');
					$('header').addClass('hovered');
					$span.text('close');
		
					let titoliHeader = document.querySelectorAll('.menu-item');

					// const $languageswitcher = $this.find('.languageswitcher');

					// gsap.fromTo($languageswitcher, {
					// 		y: '110%',
					// 		delay: 0.3,
					// 		opacity: 0,
					// 		stagger: {
					// 			each: 0.1
					// 		},
					// 	},{
					// 		y: 0,
					// 		delay: 0.3,
					// 		opacity: 1,
					// 		stagger: {
					// 			each: 0.1
					// 		},
					// 	});

		
					titoliHeader.forEach(element => {
						gsap.from(element, {
							y: '110%',
							delay: 0.3,
							opacity: 0,
							stagger: {
								each: 0.1
							},
						});
					});
				}
			});
		

			$(menuIcon).on('click', function () {
				const $this = $(this); // Salva il riferimento all'elemento cliccato
				
				const icon = $this.find('+ .icon');
				const $submenu = $this.siblings('ul.sub-menu-0');
				


				if (icon.hasClass('is-active')) {
					icon.removeClass('is-active');
					$submenu.hide().removeClass('is-active'); // Nasconde il sottomenu
				} else {
					icon.addClass('is-active');
					$submenu.show().addClass('is-active'); // Mostra il sottomenu
				}
			});		
		}
	}
}
